// extracted by mini-css-extract-plugin
export default {"alert":"EmailDrawerAlert_alert__qh7RJ","alert-cols":"EmailDrawerAlert_alert-cols__SARIe"};